import React from "react";
import { Link, useNavigate } from "react-router-dom";

export default function Loaders({ isLoaded }) {
  const navigate = useNavigate();

  return (
    <div id="preloader" style={{ display: isLoaded ? "block" : "none" }}>
      <div className="sk-three-bounce">
        <div className="sk-child sk-bounce1"></div>
        <div className="sk-child sk-bounce2"></div>
        <div className="sk-child sk-bounce3"></div>
      </div>
    </div>
  );
}
